(() => {
  const translations = {
    de: { heading: 'Soundbeispiel', info: 'Klangbeispiel', back: '10 Sekunden zurück', forward: '10 Sekunden vor', play: 'Abspielen', pause: 'Pausieren', retry: 'Erneut abspielen', error: 'Fehler', position: 'Wiedergabeposition' },
    en: { heading: 'Sound sample', info: 'Sound sample', back: 'Back 10 seconds', forward: 'Forward 10 seconds', play: 'Play', pause: 'Pause', retry: 'Try again', error: 'Error', position: 'Playback position' },
    fr: { heading: 'Extrait sonore', info: 'Extrait sonore', back: 'Reculer de 10 secondes', forward: 'Avancer de 10 secondes', play: 'Lire', pause: 'Mettre en pause', retry: 'Réessayer', error: 'Erreur', position: 'Position de lecture' }
  };

  function initializeSoundPlayers() {
    document.querySelectorAll('.sound-example').forEach(player => {
      if (player.dataset.ready) return;
      const audio = player.querySelector('audio');
      const play = player.querySelector('.sound-play');
      const bar = player.querySelector('.sound-progress');
      const time = player.querySelector('.sound-time');
      const left = player.querySelector('.sound-left');
      if (!audio || !play || !bar || !time || !left) return;
      player.dataset.ready = 'true';

      const language = (player.getAttribute('lang') || document.documentElement.lang || 'de').toLowerCase().split(/[-_]/)[0];
      const text = translations[language] || translations.de;
      const heading = player.querySelector('h3');
      const info = player.querySelector('.sound-info');
      if (heading) heading.textContent = text.heading;
      if (info) {
        info.setAttribute('aria-label', text.info);
        info.title = text.info;
      }
      bar.setAttribute('aria-label', text.position);
      player.querySelectorAll('[data-skip]').forEach(button => {
        button.setAttribute('aria-label', Number(button.dataset.skip) < 0 ? text.back : text.forward);
      });

      const format = seconds => {
        const n = Number.isFinite(seconds) ? Math.max(0, Math.floor(seconds)) : 0;
        return Math.floor(n / 60) + ':' + String(n % 60).padStart(2, '0');
      };

      function update() {
        const valid = Number.isFinite(audio.duration) && audio.duration > 0;
        const percent = valid ? audio.currentTime / audio.duration * 100 : 0;
        bar.disabled = !valid;
        bar.value = percent;
        bar.style.setProperty('--progress', percent + '%');
        bar.setAttribute('aria-valuetext', format(audio.currentTime));
        time.textContent = format(audio.currentTime);
        left.textContent = '-' + format(valid ? audio.duration - audio.currentTime : 0);
      }

      function updatePlayButton() {
        const paused = audio.paused || audio.ended;
        play.textContent = paused ? '\u25B6' : '\u275A\u275A';
        play.setAttribute('aria-label', paused ? text.play : text.pause);
      }

      play.addEventListener('click', async () => {
        if (!audio.paused) return audio.pause();
        try {
          await audio.play();
        } catch {
          time.textContent = text.error;
          play.setAttribute('aria-label', text.retry);
        }
      });

      ['play', 'pause', 'ended'].forEach(event => {
        audio.addEventListener(event, updatePlayButton);
      });
      ['timeupdate', 'loadedmetadata', 'durationchange'].forEach(event => {
        audio.addEventListener(event, update);
      });
      bar.addEventListener('input', () => {
        if (Number.isFinite(audio.duration) && audio.duration > 0) {
          audio.currentTime = bar.value / 100 * audio.duration;
          update();
        }
      });
      player.querySelectorAll('[data-skip]').forEach(button => {
        button.addEventListener('click', () => {
          if (Number.isFinite(audio.duration)) {
            audio.currentTime = Math.max(0, Math.min(audio.duration, audio.currentTime + Number(button.dataset.skip)));
            update();
          }
        });
      });
      update();
      updatePlayButton();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSoundPlayers);
  } else {
    initializeSoundPlayers();
  }
  document.addEventListener('shopify:section:load', initializeSoundPlayers);
})();